import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  progress {
    width: 100%;
    height: 3px;
    border-radius: 0px;
    -webkit-appearance: none;
  }
  progress::-webkit-progress-bar {
    background-color: white;
  }
  progress::-webkit-progress-value {
    background-color: #001eff;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 50px;
`;

export const Step = styled.span`
  color: #737373;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 22px;
  align-items: flex-end;
  margin-left: auto;
  margin-right: 16px;
`;

export const TitleLink = styled(Link)`
  text-decoration: none;

  svg {
    margin: 0 10px;
  }
`;

export const Title = styled.span`
  font-family:${({ theme }) => theme.fonts.heading};
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  color: #151515;
  justify-self: center;
  font-weight: 400;
`;
